export const HAPTIK_PARTNER_ID = "61b7478c-2a5f-471b-b1ef-40cbb0a18870";
export const THRIVE_PARTNER_ID = "1d2c2482-f358-4a0c-aa9a-0970fabf6379";
export const INTERAKT_PARTNER_ID = "c834420b-95b5-48ce-9b1a-507a9044ee37";
